import EmisorStore from './emisores/state/EmisorStore';
import UsuarioStore from './usuarios/state/UsuarioStore';
import CatalogoStore from './catalogs/state/CatalogoStore';
import ReceptorStore from './receptores/state/ReceptorStore';
import RetencionesStore from './retenciones/state/RetencionesStore';
import ComprobanteStore from './comprobantes/state/ComprobanteStore';
import HitsUsageListStore from './reporting/state/HitsUsageListStore';
import PrefacturaInfoStore from './prefacturas/state/PrefacturaInfoStore';
import PrefacturaListStore from './prefacturas/state/PrefacturaListStore';
import DashboardSummaryStore from './dashboard/state/DashboardSummaryStore';
import PrefacturaUpsertStore from './prefacturas/state/PrefacturaUpsertStore';
import EmpresasListStore from './empresas/state/EmpresasListStore';

const AppStore = {
  empresas: {
    list: EmpresasListStore,
  },
  catalogos: CatalogoStore,
  comprobantes: ComprobanteStore,
  retenciones: RetencionesStore,
  dashboard: {
    summary: DashboardSummaryStore,
  },
  emisores: EmisorStore,
  receptores: ReceptorStore,
  usuarios: UsuarioStore,
  prefacturas: {
    list: PrefacturaListStore,
    info: PrefacturaInfoStore,
    upsert: PrefacturaUpsertStore,
  },
  reports: {
    hitsUsage: HitsUsageListStore,
  },
};

export default AppStore;
